var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.713,
    height: 23.195,
    viewBox: "0 0 28.713 23.195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_25860",
    "data-name": "Path 25860",
    d: "M28.067,45.254a15.7,15.7,0,0,0,15.8-15.8c0-.241,0-.48-.016-.718a11.286,11.286,0,0,0,2.771-2.876,11.114,11.114,0,0,1-3.189.874,5.575,5.575,0,0,0,2.442-3.072,11.119,11.119,0,0,1-3.526,1.348,5.559,5.559,0,0,0-9.465,5.065,15.766,15.766,0,0,1-11.447-5.8,5.558,5.558,0,0,0,1.719,7.414,5.5,5.5,0,0,1-2.515-.695c0,.023,0,.047,0,.071A5.557,5.557,0,0,0,25.1,36.506a5.554,5.554,0,0,1-2.509.095,5.561,5.561,0,0,0,5.188,3.858,11.142,11.142,0,0,1-6.9,2.377,11.294,11.294,0,0,1-1.325-.077,15.722,15.722,0,0,0,8.513,2.495",
    transform: "translate(-19.285 -22.559)",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterOutline);
export default __webpack_public_path__ + "static/media/twitter-outline.7fa57a14c40c8125132519a2870f78cb.svg";
export { ForwardRef as ReactComponent };